import { MantineThemeOverride } from "@mantine/core";

const AppTheme: MantineThemeOverride = {
  fontFamily: "inherit",
  colors: {
    brand: [
      "#d7fcff",
      "#abedff",
      "#7ae0ff",
      "#48d2ff",
      "#1ac6ff",
      "#00ace6",
      "#0086b4",
      "#006082",
      "#003a51",
      "#001520",
    ],
  },
  primaryColor: "brand",
};

export enum AppColors {
  Red = "#fa5252",
}

export const AppMediaQueries = {
  xs: "(min-width: 576px)",
  sm: "(min-width: 768px)",
  md: "(min-width: 992px)",
  lg: "(min-width: 1200px)",
  xl: "(min-width: 1400px)",
};

export default AppTheme;
